<nav id="custom-pagination-nav" aria-label="Page navigation example" class="ml-auto">
    <ngb-pagination *ngIf="count" [page]="currentPage" [pageSize]="pageSize" [collectionSize]="count" [rotate]="true"
        [boundaryLinks]="true" [maxSize]="maxSize" (pageChange)="onPageChange($event)">
        <ng-template ngbPaginationPrevious>Prev</ng-template>
        <ng-template ngbPaginationNext>Next</ng-template>
        <ng-template ngbPaginationFirst>First</ng-template>
        <ng-template ngbPaginationLast>Last</ng-template>
    </ngb-pagination>
</nav>